import { Button, Flex, Modal, Skeleton } from "antd";
import { useState } from "react";
import {
  AlertTextModal,
  buttonStyle,
  ContainerModal,
  ContainerModalPix,
  TextModal,
  TextModal2,
  TextModalPix,
  TextPix,
} from "../styles";
import ModalIncluir from "./ModalIncluir";
import ModalEditar from "./ModalEditar";
import ModalExcluir from "./ModalExcluir";
import { useInfoPagamentoAtivo } from "../Hooks/useInfoPagamentoAtivo";
import { useWarning } from "../../../uteis/mensagens/useWarning";

export default function ModalInfoPagamento({
  isModalOpen,
  handleFechar,
  usuarioId,
}: any) {
  // State para armazenar o modal ativo
  const [modalAtivo, setModalAtivo] = useState<string | null>(null);

  // Função para abrir um modal específico
  const abrirModal = (modalName: string | null) => {
    setModalAtivo(modalName);
  };

  // Função para fechar o modal
  const fecharModal = () => {
    setModalAtivo(null);
  };
  const { isLoading, infoPagData } = useInfoPagamentoAtivo(usuarioId);

  // Exibe a Mensagem de  Erro
  const { showWarning, contextHolder } = useWarning();

  return (
    <>
      <Modal open={isModalOpen} onCancel={handleFechar} footer={null}>
        <>{contextHolder}</>
        {isLoading && <Skeleton active />}
        {!isLoading && (
          <>
            <Flex
              vertical
              gap="small"
              style={{
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                height: "50vh", // Para centralizar verticalmente
              }}
            >
              <ContainerModalPix>
                {infoPagData?.pix ? (
                  <>
                    <TextModalPix>
                      Chave Pix<TextPix> {infoPagData?.pix}</TextPix>
                    </TextModalPix>
                  </>
                ) : (
                  <AlertTextModal>
                    Não há nenhuma chave pix ativa
                  </AlertTextModal>
                )}
              </ContainerModalPix>
              <Button onClick={() => abrirModal("Incluir")} style={buttonStyle}>
                Incluir
              </Button>
              <Button
                onClick={() =>
                  infoPagData
                    ? abrirModal("Editar")
                    : showWarning("Não há nenhuma chave pix ativa!")
                }
                style={buttonStyle}
              >
                Editar
              </Button>
              <Button
                onClick={() =>
                  infoPagData
                    ? abrirModal("Excluir")
                    : showWarning("Não há nenhuma chave pix ativa!")
                }
                style={buttonStyle}
              >
                Excluir
              </Button>
            </Flex>
            {modalAtivo === "Incluir" && (
              <ModalIncluir
                isModalOpen={!!modalAtivo}
                handleFechar={fecharModal}
                usuarioId={usuarioId}
              />
            )}
            {modalAtivo === "Editar" && (
              <ModalEditar
                isModalOpen={!!modalAtivo}
                handleFechar={fecharModal}
                usuarioId={usuarioId}
              />
            )}
            {modalAtivo === "Excluir" && (
              <ModalExcluir
                isModalOpen={!!modalAtivo}
                handleFechar={fecharModal}
                usuarioId={usuarioId}
              />
            )}
          </>
        )}
      </Modal>
    </>
  );
}
